import ActionsForm from '@/shared/mixins/actionsForm'
import MiscellaneousExpensesRepository from '@/shared/http/repositories/business/miscellaneousexpenses'
import TravelExpenseRepository from '@/shared/http/repositories/business/travelexpense.js'
import { loading, toast } from '@/shared/utils/UIHelper'
import MidiaMiscellaneous from '@/shared/http/repositories/business/midiamiscellaneous.js'
import Tools from '@/components/tools/Tools'
import addCoordinator from '../addCoordinator/addCoordinator.vue'
import { fluxoReprovacao } from '../../fluxoReprovacaoDiversos'

export default {
  mixins: [ActionsForm],
  components: {addCoordinator},
  props: ['despesasid', 'filtroEmpresa'],
  emits: ['totalFuncionarioDespesas'],
  data () {
    return {
      TipoReprova: false,
      motivo: null,
      coluna: [],
      dataFormSearch: {
        SubCategoriaEnum: null,
        StatusDespesa: null
      },
      despesasidEnviarCoordenador: null,
      UnicaDespesa: null,
      dataDespesas: [],
      despesasSelecionada: {},
      isPdf: false,
      isExcel: false,
      isMSG: false,
      arquivodespesaid: {},
      nomeArquivo: '',
      arquivoFormato: '',
      type: null,
      midiapdf: null,
      base64: null,
      despesaid: null,
      posicaoSelecionada: null,
      definitivo: false,
      titleReprovacao: null,
      impedeDevolucao: false,
      temCoordenador: false,
      usuarioGrupoDV: {}
    }
  },
  computed: {
    modalTitle () {
      return `COMPROVANTE ( ${this.posicaoSelecionada + 1} / ${this.dataDespesas.length} )`
    }
  },
  mounted () {
    this.GetDespesasByFuncioarioId()
    this.colunaVerifica()
  },

  methods: {
    modalDevolucaoUnicaDespesa () {
      this.UnicaDespesa = true
      this.$refs['modal-EscolhaReprova'].show()
    },
    voltarEscolhaReprova () {
      this.$refs['modal-EscolhaReprova'].hide()
    },
    colunaVerifica () {
      if (this.hasRole(this.roles.RW_REAL_ESTA_ADMIN) || this.hasRole(this.roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL)) {
        this.coluna = ['Data das Despesas', 'Situação', 'Categoria', 'Quantidade', 'Funcionários Vinculados', 'Valor', '']
      } else {
        // this.coluna = ['Data das Despesas', 'Categoria', 'Quantidade', 'Funcionários Vinculados', 'Valor', '']
        if (this.usuarioGrupoDV.isCoordenador || this.usuarioGrupoDV.isTecnico) {
          this.coluna = ['Pré-aprovada', 'Data das Despesas', 'Categoria', 'Quantidade', 'Funcionários Vinculados', 'Valor', '']
        } else {
          this.coluna = ['Data das Despesas', 'Categoria', 'Quantidade', 'Funcionários Vinculados', 'Valor', '']
        }
      }
    },
    GetDespesasByFuncioarioId (data) {
      if (this.filtroEmpresa != null) {
        this.dataFormSearch.CompanyId = this.filtroEmpresa
      } else {
        this.dataFormSearch.CompanyId = this.CompanySelected
      }
      this.dataFormSearch.TipoPerfil = 0
      loading.push()
      if (data != null && data !== undefined) {
        this.dataFormSearch.SubCategoriaEnum = data.categoria
        this.dataFormSearch.StatusDespesa = parseInt(data.situacao)

        var formData = new FormData()

        formData.append('filtroJson', JSON.stringify(this.dataFormSearch))
        if (this.hasRole(this.roles.RW_REAL_ESTA_ADMIN) || this.hasRole(this.roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL)) {
          MiscellaneousExpensesRepository.SearchDespesasFuncionarioIdAdmin(this.despesasid, this.dataFormSearch.CompanyId, this.dataFormSearch.TipoPerfil, this.$refs.tableGridsDetalhesPrestacaoContasDiversos.pagingLimit, this.$refs.tableGridsDetalhesPrestacaoContasDiversos.pagingIndex, formData)
            .then((Response) => {
              this.dataFuncionario = []
              this.dataDespesas = Response.data.data
              let total = 0
              this.dataDespesas.forEach((Element) => {
                total += Element.valor
              })
              this.$emit('totalFuncionarioDespesas', total)
              this.$emit('despesasLoaded', this.dataDespesas)
              this.dataFuncionario = this.dataDespesas
              this.$refs.tableGridsDetalhesPrestacaoContasDiversos.LoadAllByData(Response)
              loading.pop()
            })
            .catch((Error) => {
              loading.pop()
            })
        } else {
          MiscellaneousExpensesRepository.SearchDespesasFuncionarioId(this.despesasid, this.dataFormSearch.CompanyId, this.dataFormSearch.TipoPerfil, this.$refs.tableGridsDetalhesPrestacaoContasDiversos.pagingLimit, this.$refs.tableGridsDetalhesPrestacaoContasDiversos.pagingIndex, formData)
            .then((Response) => {
              this.dataFuncionario = []
              this.dataDespesas = Response.data.data
              let total = 0
              this.dataDespesas.forEach((Element) => {
                total += Element.valor
              })
              this.$emit('totalFuncionarioDespesas', total)
              this.$emit('despesasLoaded', this.dataDespesas)
              this.dataFuncionario = this.dataDespesas
              this.$refs.tableGridsDetalhesPrestacaoContasDiversos.LoadAllByData(Response)
              loading.pop()
            })
            .catch((Error) => {
              loading.pop()
            })
        }
      } else {
        if (this.hasRole(this.roles.RW_REAL_ESTA_ADMIN) || this.hasRole(this.roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL)) {
          MiscellaneousExpensesRepository.GetDespesasByFuncioarioIdAdmin(this.despesasid, this.dataFormSearch.CompanyId, this.dataFormSearch.TipoPerfil, this.$refs.tableGridsDetalhesPrestacaoContasDiversos.pagingLimit, this.$refs.tableGridsDetalhesPrestacaoContasDiversos.pagingIndex)
            .then((Response) => {
              this.dataFuncionario = []
              this.dataDespesas = Response.data.data
              let total = 0
              this.dataDespesas.forEach((Element) => {
                total += Element.valor
              })
              this.$emit('totalFuncionarioDespesas', total)
              this.$emit('despesasLoaded', this.dataDespesas)
              this.dataFuncionario = this.dataDespesas
              this.$refs.tableGridsDetalhesPrestacaoContasDiversos.LoadAllByData(Response)
              loading.pop()
            })
            .catch((Error) => {
              loading.pop()
            })
        } else {
          MiscellaneousExpensesRepository.GetUsuarioGrupoDespesaViagem()
            .then((Response) => {
              this.usuarioGrupoDV = Response.data.data
              this.colunaVerifica()
            })
          MiscellaneousExpensesRepository.GetDespesasByFuncioarioId(this.despesasid, this.dataFormSearch.CompanyId, this.dataFormSearch.TipoPerfil, this.$refs.tableGridsDetalhesPrestacaoContasDiversos.pagingLimit, this.$refs.tableGridsDetalhesPrestacaoContasDiversos.pagingIndex)
            .then((Response) => {
              this.dataFuncionario = []
              this.dataDespesas = Response.data.data
              let total = 0
              this.dataDespesas.forEach((Element) => {
                total += Element.valor
              })
              this.$emit('totalFuncionarioDespesas', total)
              this.$emit('despesasLoaded', this.dataDespesas)
              this.dataFuncionario = this.dataDespesas
              this.$refs.tableGridsDetalhesPrestacaoContasDiversos.LoadAllByData(Response)
              loading.pop()
            })
            .catch((Error) => {
              loading.pop()
            })
        }
      }
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    onSelect (data) {
      this.$emit('detailsDespesa', data)
    },
    getselected () {
      let ids = this.dataDespesas.map((Element) => Element)
      let dataListIdsChecked = []
      ids.forEach((Element) => {
        let input = document.getElementById(Element.id)
        if (input !== null && input !== undefined) {
          if (input.checked) dataListIdsChecked.push(Element)
        }
      })
      if (dataListIdsChecked.length !== 0) {
        return dataListIdsChecked
      } else {
        toast.warning('Selecione uma despesa!')
        loading.pop()
      }
    },

    getchecked () {
      let arrayids = this.dataDespesas.map((Element) => Element.id)
      let lstapprove = []
      arrayids.forEach((Element) => {
        let input = document.getElementById(Element)
        if ((input !== undefined || input !== null) && input.checked === true) {
          lstapprove.push(Element)
        }
      })
      return lstapprove
    },
    getselectedStatus () {
      let status = this.dataDespesas.map((Element) => Element.statusDespesa)
      let dataListIdsChecked = []
      status.forEach((Element) => {
        dataListIdsChecked.push(Element)
      })
      return dataListIdsChecked
    },
    openPopup (Response) {
      this.temCoordenador = Response.coordenadorID
      this.midiapdf = null
      this.despesasSelecionada = Response
      this.impedeDevolucao = false
      if (this.despesasSelecionada.primeiroAdiantamento || this.despesasSelecionada.saldo || this.despesasSelecionada.reforco || this.despesasSelecionada.reforcoDescontar) {
        this.impedeDevolucao = true
      }
      this.despesaid = Response.id
      this.posicaoSelecionada = this.dataDespesas.indexOf(this.despesasSelecionada)
      if (this.posicaoSelecionada < 0) {
        this.posicaoSelecionada = this.dataDespesas.indexOf(this.despesasSelecionada) + 1
      }
      this.getcomprovantebyfuncionarioid(Response)
      this.$refs['openModalDetail'].show(Response)
    },
    closePopup () {
      this.arquivodespesaid = {}
      this.despesasSelecionada = {}
      this.$refs['openModalDetail'].hide()
    },
    downloadComprovante () {
      if (this.base64 != null) {
        var a = document.createElement('a')
        const typefile = 'v,slv'.includes('.pdf') ? 'application/pdf' : 'image/png'
        a.href = `data:${typefile};base64,` + this.base64
        a.download = this.nomeArquivo
        a.click()
        toast.success('Sucesso ao fazer o Donwload')
      } else {
        toast.warning('Erro ao fazer Download')
      }
    },
    openDetailsimg () {
      this.$refs['Detailsimg'].show()
    },
    closeDetailsimg () {
      this.$refs['Detailsimg'].hide()
    },
    Aprove () {
      loading.push()
      MiscellaneousExpensesRepository.NextStatus(this.despesasSelecionada.id)
        .then((Response) => {
          this.GetDespesasByFuncioarioId()
          toast.success('Aprovado com sucesso')
          this.midiapdf = null
          this.NextPopup()
          loading.pop()
          this.dataDespesas = []
          this.despesasSelecionada = {}
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    PreAprove () {
      loading.push()
      MiscellaneousExpensesRepository.PreApprovedDespesaByid(this.despesasSelecionada.id)
        .then((Response) => {
          this.despesasSelecionada.preAprovada = 'Sim'
          // this.GetDespesasByFuncioarioId()
          toast.success('Pré-aprovado com sucesso')
          this.midiapdf = null
          // this.NextPopup()
          loading.pop()
          // this.dataDespesas = []
          this.despesasSelecionada = {}
          this.$refs['openModalDetail'].hide()
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    NextPopup () {
      if (this.hasRole(this.roles.RW_REAL_ESTA_ADMIN) || this.hasRole(this.roles.ACC_FIN_MISCELCOORDINATORLANEOUS_SEARCH_CONTROLLER_APPROVAL) || this.hasRole(this.roles.ACC_FIN_MISCELTECHNICIANLANEOUS_SEARCH_CONTROLLER_APPROVAL)) {
        MiscellaneousExpensesRepository.GetDespesasByFuncioarioId(this.despesasid, this.CompanySelected, this.$refs.tableGridsDetalhesPrestacaoContasDiversos.pagingLimit, this.$refs.tableGridsDetalhesPrestacaoContasDiversos.pagingIndex)
          .then((Response) => {
            if (Response.data.data.length === 0) {
              this.GetDespesasByFuncioarioId()
              this.despesasSelecionada = []
              this.$refs['openModalDetail'].hide()
            } else {
              this.despesasSelecionada = Response.data.data[0]
              this.openPopup(this.despesasSelecionada)
            }
          })
      }
      if (this.hasRole(this.roles.RW_REAL_ESTA_ADMIN) || this.hasRole(this.roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL)) {
        MiscellaneousExpensesRepository.GetDespesasByFuncioarioIdAdmin(this.despesasid, this.CompanySelected, this.$refs.tableGridsDetalhesPrestacaoContasDiversos.pagingLimit, this.$refs.tableGridsDetalhesPrestacaoContasDiversos.pagingIndex)
          .then((Response) => {
            if (Response.data.data.length === 0) {
              this.GetDespesasByFuncioarioId()
            } else {
              this.despesasSelecionada = Response.data.data[0]
              this.openPopup(this.despesasSelecionada)
            }
          })
      }
    },
    modalDevolucao () {
      this.definitivo = false
      this.$refs['devolver-despesa'].show()
    },
    modalDefinitivo () {
      this.definitivo = true
      this.$refs['devolver-despesa'].show()
    },
    voltar () {
      this.motivo = null
      this.$refs['devolver-despesa'].hide()
    },
    Reprove (ReprovacaoDefinitiva) {
      const fluxo = fluxoReprovacao(this.despesasSelecionada.statusDespesa, (r) => this.hasRole(r))
      if (fluxo === null) {
        toast.warning('Selecione uma despesa válida para a reprovação')
        return
      }
      loading.push()
      if (ReprovacaoDefinitiva === true) {
        this.TipoReprova = true
      }
      MiscellaneousExpensesRepository.Reprove({motivoRecusa: this.motivo, despesasdiversosid: this.despesasSelecionada.id, Fluxo: fluxo, ReprovacaoDefinitiva: this.TipoReprova})
        .then((Response) => {
          toast.success('Reprovado com sucesso')
          this.midiapdf = null
          this.voltarEscolhaReprova()
          this.voltar()
          this.closePopup()
          this.GetDespesasByFuncioarioId(null)
          loading.pop()
          this.dataDespesas = []
          this.NextPopup()
        })
        .catch((Error) => {
          loading.pop()
          toast.error('Erro ao reprovar a despesa!')
        })
    },
    async getcomprovantebyfuncionarioid (e) {
      this.arquivodespesaid = null
      this.nomeArquivo = null
      this.base64 = null
      if (!e.saldo) {
        MidiaMiscellaneous.GetByDespesaDiversosId(e.id)
          .then(Response => {
            this.arquivodespesaid = Response
            this.nomeArquivo = Response.data.arquivo.name
            this.arquivoFormato = this.nomeArquivo.replace(/^.*\./, '')
            this.getarquivo64()
            this.loadImage()
          })
          .catch((Error) => {
            toast.error('Erro ao fazer Download')
            loading.close()
          })
      }
    },
    async loadImage () {
      loading.push()
      let midiaName = this.arquivodespesaid.data.arquivo.name
      this.type = this.arquivodespesaid.data.arquivo.name.split('.').pop()
      this.isPdf = midiaName.toLowerCase().includes('pdf')
      this.isExcel = midiaName.toLowerCase().includes('xlsx')
      this.isMSG = midiaName.toLowerCase().includes('msg')
      TravelExpenseRepository.Download(this.arquivodespesaid.data.arquivo.id, this.CompanySelected).then((e) => {
        this.midiapdf = e.data
      }).catch(() => {
        toast.error('Não foi possivel carregar o comprovante')
        loading.pop()
      })
        .finally(() => { loading.pop() })
    },
    getarquivo64 () {
      if (this.base64 != null) {
        this.base64 = null
      }
      TravelExpenseRepository.Download(this.arquivodespesaid.data.arquivoID, this.CompanySelected)
        .then(Response => {
          if (Response.data) {
            this.base64 = Response.data
            loading.close()
          }
        })
        .catch((Error) => {
          toast.error(Error)
          loading.close()
        })
    },
    eventcheck (e) {
      let checkedDataDespesas = this.dataDespesas.filter((element) => {
        let input = document.getElementById(element.id)
        if (input !== undefined && input !== null) {
          element.checked = e.checked
          input.checked = e.checked
          return e.checked
        }
        return false
      })
      this.$emit('eventcheck', checkedDataDespesas)
    },
    checkfalse () {
      this.$refs.tableGridsDetalhesPrestacaoContasDiversos.limpaCheckDespesa()
    },
    uncheckAllCheckboxes () {
      var checkboxes = document.querySelectorAll('.check-table')
      checkboxes.forEach(function (checkbox) {
        checkbox.checked = false
      })
    },
    alertsStyle () {
      return {
        'button-disabled': this.impedeDevolucao === true,
        'button-info': this.impedeDevolucao === false
      }
    },
    aprovaUnicaDespesa (value) {
      this.UnicaDespesa = true
      this.despesasidEnviarCoordenador = value
      this.$refs['modal-envio-coordenador'].show()
    },
    onloadReacarregar () {
      this.GetDespesasByFuncioarioId(null)
      this.NextPopup()
      this.$refs['modal-envio-coordenador'].hide()
    },
    fecharEnviarCoordenador () {
      this.$refs['modal-envio-coordenador'].hide()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/miscellaneousreimbursement/components/tableoccourenciadetails/tableoccourenciadetails.js